import React, { useEffect, useState } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import LocalEstoqueModal from './modals/LocalEstoque';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';

const LocaisEstoques = () => {
  const [error, setError] = useState(null);

  const [localEstoque, setLocalEstoque] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');

  const [selectedLocalEstoque, setSelectedLocalEstoque] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchLocalEstoque = async (currentPage) => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await api.get(`/localEstoques?page=${currentPage}&limit=${limit}&nome=${filtroNome}`);

      setLocalEstoque(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
      Swal.close();
    } catch (err) {
      setError('Erro ao carregar a lista de locais de estoque.');
      Swal.close();
    }
  };

  useEffect(() => {
    fetchLocalEstoque(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddLocalEstoque = () => {
    setSelectedLocalEstoque(null);
    setIsModalOpen(true);
  };

  const handleEditLocalEstoque = (local) => {
    setSelectedLocalEstoque(local);
    setIsModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchLocalEstoque(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
  };

  const handleDeleteLocalEstoque = (local) => {
    Swal.fire({
      title: 'Aviso',
      text: 'Deseja deletar o local de estoque?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, confirmar!',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/localEstoques/${local.id}`);

          fetchLocalEstoque(currentPage);
          Swal.fire('Sucesso', 'Local de estoque deletado com sucesso!', 'success');
        }
        catch (error) {
          Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Locais de Estoque</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-8 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddLocalEstoque}>
                <FaPlus /> Adicionar Local de Estoque
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-4 col-md-6 col-12">
              <label className="form-label fw-bold">Nome do Local</label>
              <input
                type="text"
                placeholder="Digite o nome do local do estoque"
                autoComplete="off"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-8 col-md-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="table-custom-primary">
                    <tr>
                      <th>Nome</th>
                      <th className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {localEstoque.length === 0 ? (
                      <tr>
                        <td colSpan="2" className="text-center">
                          Nenhum local de estoque encontrado.
                        </td>
                      </tr>
                    ) : (
                      localEstoque.map((local) => (
                        <tr key={local.id}>
                          <td className="text-nowrap">{local.nome}</td>
                          <td className="text-center">
                            <button
                              className="btn btn-custom-secondary btn-sm"
                              onClick={() => handleEditLocalEstoque(local)}
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleDeleteLocalEstoque(local)}
                            >
                              <FaTrashAlt />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {isModalOpen && (
          <LocalEstoqueModal
            local={selectedLocalEstoque}
            onClose={() => setIsModalOpen(false)}
            onLocalEstoqueAtualizado={() => fetchLocalEstoque(currentPage)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default LocaisEstoques;

